<template>
  <div id="User" class="animated fadeIn" @click.self="close">
    <div v-if="isShowWrapper" class="wrapper slideInLeft">
      <router-link
        tag="div"
        class="unauth"
        to="/login"
        v-if="!$store.state.user || !$store.state.user.user_id"
      >
        <div>
          <div class="circle">
            <i class="anyteachicon anyteach-icon-test" />
          </div>
          <span>请先登录</span>
        </div>
      </router-link>
      <div v-else>
        <div class="header">
          <div class="img" :style="$bgd(user.gravatar)" />
          <div class="name">
            <h1>{{ user.name }}</h1>
            <p v-if="$store.state.info.identity && user.identity > 1">
              {{ $store.state.info.identity[user.identity] }}
              <i
                class="anyteachicon anyteach-shenfen1"
              />
            </p>
            <router-link tag="h2" to="/me">查看个人信息</router-link>
          </div>
        </div>
        <h3 v-if="user.credit">{{ user.credit }} 学分</h3>
        <div class="routes">
          <router-link
            v-for="(route, index) in routes"
            :key="index"
            :to="route.url"
            tag="div"
            class="route"
          >{{ route.name }}</router-link>
          <div class="secondary-routes">
            <router-link
              v-for="(route, index) in secondaryRoutes"
              :key="index"
              :to="route.url"
              tag="div"
              class="route secondary"
            >{{ route.name }}</router-link>
          </div>
        </div>
        <div class="logout" v-if="!$store.state.isWechat" @click="logout">
          <i class="anyteachicon anyteach-tuichu" />退出登录
        </div>
        <div class="version">
          <span>AnyTeach 约课平台</span>
          <i class="anyteachicon anyteach-tags" />
          <span>{{ version }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { version } from "../../../package.json"
import Dialog from "mand-mobile/lib-vw/dialog"

export default {
  name: "User",
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  data() {
    return {
      isStaff: false,
      version: version,
      isShowWrapper: false,
      routes: [
        { name: "邀请好友", url: "/invite/reward", badge: "", icon: "" },
        { name: "学习券", url: "/coupons", badge: "", icon: "anyteachicon anyteach-youhuiquan1" },
        // { name: "教材体系", url: "/progress", badge: "", icon: "" },
        {
          name: "支付历史",
          url: "/payments",
          badge: "",
          icon: "anyteachicon anyteach-dollar-sign",
        },
        { name: "提现钱包", url: "/cash", badge: "", icon: "" },
        { name: "考试报告", url: "/exams", badge: "", icon: "" },
        { name: "我的课表", url: "/schedule", badge: "", icon: "" },
      ],
      secondaryRoutes: [
        { name: "服务条款", url: "/agreement", icon: "" },
        { name: "联系小管家", url: "/contact", icon: "" },
      ],
    }
  },
  deactivated() {
    this.$enableScroll()
  },
  created() {
    this.$disableScroll()
    setTimeout(() => {
      this.isShowWrapper = true
    }, 200)
    this.getStaffProfile()
  },
  methods: {
    logout() {
      Dialog.confirm({
        title: "退出登录",
        content: "您确定要退出当前账号吗？",
        confirmText: "确认",
        cancelText: "取消",
        onConfirm: () => {
          this.close()
          this.$api.auth.LOGOUT().then(({ code, msg }) => {
            if (code == 1000) {
              this.$store.commit("login", false)
              this.$toastSuccess("退出成功")
            }
          })
        },
      })
    },
    async getStaffProfile() {
      this.isStaff = await this.$api.store.PROFILE()
    },
    close() {
      document.getElementById("User").classList.remove("fadeIn")
      document.getElementById("User").classList.add("fadeOut")
      document.getElementsByClassName("wrapper")[0].classList.remove("slideInLeft")
      document.getElementsByClassName("wrapper")[0].classList.add("slideOutLeft")
      document.body.classList.remove("noscroll")
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#User {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: block;
  z-index: 1000;
  animation-duration: 0.5s !important;
  animation-delay: 0.1s !important;
  -webkit-animation-duration: 0.5s !important;
  -webkit-animation-delay: 0.1s !important;
  @include avenir();

  .unauth {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    .circle {
      margin: 0 auto 5px auto;
      background: $lightBlue;
      color: $blue;
      font-size: 20px;
      border-radius: 45px;
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      i {
        font-weight: 900;
      }
    }
    span {
      font-size: 0.9rem;
    }
  }
  .header {
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .img {
      min-width: 70px;
      min-height: 70px;
      background-color: #efefef;
      background-position: center;
      background-size: cover;
      border-radius: 100%;
      margin: 0 15px 0 0;
    }

    .name {
      width: calc(95% - 70px);
      p {
        font-size: 0.9rem;
        i {
          color: $blue;
        }
      }
    }

    h1 {
      font-size: 22px;
      @include avenir-demi();
      white-space: nowrap;
      line-height: 1.2;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 0;
    }

    h2 {
      display: block;
      font-size: 0.9rem;
      opacity: 0.6;
      font-weight: 400;
      margin: 3px 0 0 0;
      line-height: 1.2;
    }
  }

  h3 {
    font-size: 15px;
    color: #7f7f7f;
    font-weight: 400;
    margin: 5px 20px;
  }

  .wrapper {
    background: white;
    width: 80%;
    max-width: 300px;
    height: 100%;
    padding: 5% 0 10% 0;
    overflow: scroll !important;
  }

  .routes {
    hr {
      height: 1px;
      background: #d9d9d9;
      opacity: 0.7;
      margin: 10px 0 10px 20px;
    }

    .route {
      width: 100%;
      padding: 15px 20px;
      font-style: 15px;
      font-weight: 500;
      color: $black;
      transition: all 0.1s;

      &:active {
        background: #f6f6f6;
      }
      i {
        display: inline-block;
        width: 20px;
        display: none;
      }
    }

    .secondary {
      opacity: 0.6;
      font-size: 0.9rem;
      font-weight: 400;
      padding: 5px 20px;
    }
  }
  .logout {
    @include avenir-demi();
    padding: 10px 20px;
    color: $blue;
    font-size: 0.9rem;
    &:active {
      background: #f6f6f6;
    }

    i {
      font-size: inherit;
      margin: 0 3px 0 0;
    }
  }

  .secondary-routes {
    margin: 15px 0;
  }

  .version {
    margin: 0 20px;
    font-size: 0.8rem;
    opacity: 0.6;
    span {
      @include avenir-demi();
    }
    i {
      transform: scale(0.8);
    }
  }
  /* 动画 */
  @keyframes slideInLeftAnim {
    from {
      margin-left: -80%;
    }

    to {
      margin-left: 0;
    }
  }

  @keyframes slideOutLeftAnim {
    from {
      margin-left: 0;
    }

    to {
      margin-left: -80%;
    }
  }

  .slideInLeft {
    animation: slideInLeftAnim 0.3s cubic-bezier(0.46, 0.03, 0.52, 0.96);
  }

  .slideOutLeft {
    animation: slideOutLeftAnim 0.3s cubic-bezier(0.47, 0, 0.75, 0.72);
    margin-left: -80%;
  }
}
</style>
